/* Maison Écharpe · panier 02-11 : bouton « Ajouter » du bloc « Va bien avec » (snippets/me-va-bien), SANS quitter le tiroir.
   Le tiroir est re-rendu par morph à chaque changement : un écouteur posé sur les boutons serait perdu, d'où la
   délégation sur document, posée une seule fois par ce module chargé dans layout/theme.liquid.
   Même mécanique que product-form.js du thème :
     1. on publie un CartLinesUpdateEvent (@shopify/events) avec une promesse ;
     2. POST /cart/add.js en demandant le rendu des sections des cart-items-component présents (le tiroir) ;
     3. on lit /cart.js et on résout la promesse avec { cart, detail.sections } : component-cart-items.js morphe le
        tiroir avec le HTML rendu, cart-icon.js et header-actions.js mettent la pastille à jour. */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const routes = () => (typeof Theme !== 'undefined' && Theme.routes) || { cart_add_url: '/cart/add.js', cart_url: '/cart' };

document.addEventListener('click', async (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-me-vba-add]') : null;
  if (!btn || btn.disabled) return;
  event.preventDefault();
  const id = btn.getAttribute('data-me-vba-add');
  const libelle = btn.textContent;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  btn.textContent = 'Ajout…';

  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c instanceof HTMLElement && c.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const r = await fetch(routes().cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const res = await r.json();
    if (res.status) throw Object.assign(new Error(res.description || res.message || 'Ajout impossible'), { code: 'INVALID' });
    const cart = await fetch(`${routes().cart_url}.js`, { headers: { Accept: 'application/json' } }).then((x) => x.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: 1, source: 'me-va-bien', sections: res.sections, didError: false },
    });
  } catch (error) {
    deferred.reject(error);
    btn.dispatchEvent(new CartErrorEvent({ error: error?.message || 'Ajout impossible', code: error?.code || 'SERVICE_UNAVAILABLE' }));
    btn.textContent = 'Indisponible';
    setTimeout(() => {
      btn.textContent = libelle;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }, 2500);
  }
});

/* ── Panier façon Rue des Peignoirs (02-11) : la carte complémentaire unique (snippets/pn-duo) ──────────────────────────
   - le menu de variante met à jour le bouton « + », la photo et le prix ; le prix remisé (−20 %) ne s'affiche que si la
     variante coûte au plus autant que l'article du panier (data-ref) : la remise tombe sur le MOINS CHER des deux ;
   - « + » sans taille choisie : le menu est mis en avant, rien n'est ajouté ;
   - « + » : POST /cart/add.js avec les sections des <cart-items-component>, puis CartLinesUpdateEvent, comme
     product-form.js du thème — component-cart-items.js re-rend le tiroir par morph, la pastille se met à jour.
   Délégation sur document : le tiroir est remplacé à chaque changement. */
import { CartLinesUpdateEvent as PnLignes } from '@shopify/events';

const pnRoutes = () => (typeof Theme !== 'undefined' && Theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };
const pnUrl = (u) => (u.endsWith('.js') ? u : `${u}.js`);

document.addEventListener('change', (e) => {
  const sel = e.target instanceof Element ? e.target.closest('[data-pn-select]') : null;
  if (!sel) return;
  const duo = sel.closest('[data-pn-duo]');
  const opt = sel.selectedOptions[0];
  if (!duo || !opt || !opt.value) return;
  const btn = duo.querySelector('[data-pn-ajout]');
  if (btn) btn.dataset.pnAjout = opt.value;
  const aide = duo.querySelector('[data-pn-aide]');
  if (aide) aide.hidden = true;
  sel.classList.remove('is-a-choisir');
  const img = duo.querySelector('[data-pn-img]');
  if (img && opt.dataset.img) img.src = opt.dataset.img;
  const prix = duo.querySelector('[data-pn-prix]');
  if (!prix) return;
  const offre = duo.dataset.offre === 'true';
  const remise = offre && Number(opt.dataset.prix) <= Number(duo.dataset.ref);
  prix.innerHTML = remise
    ? `<b>${opt.dataset.remiseTxt}</b> <s>${opt.dataset.prixTxt}</s> <span class="pn-duo__badge">−20&nbsp;%</span>`
    : `<b>${opt.dataset.prixTxt}</b>${offre ? ' <span class="pn-duo__note">−20&nbsp;% sur le moins cher des deux</span>' : ''}`;
});

document.addEventListener('click', async (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-pn-ajout]') : null;
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const duo = btn.closest('[data-pn-duo]');
  const id = btn.dataset.pnAjout;
  if (!id) {
    const sel = duo && duo.querySelector('[data-pn-select]');
    const aide = duo && duo.querySelector('[data-pn-aide]');
    if (aide) aide.hidden = false;
    if (sel) { sel.classList.add('is-a-choisir'); sel.focus(); }
    return;
  }
  btn.disabled = true;
  btn.classList.add('is-chargement');

  const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
    .map((c) => (c instanceof HTMLElement ? c.dataset.sectionId : '')).filter(Boolean))];
  const fd = new FormData();
  fd.append('id', id);
  fd.append('quantity', '1');
  if (sections.length) fd.append('sections', sections.join(','));

  const differe = PnLignes.createPromise();
  document.dispatchEvent(new PnLignes({
    action: 'add', context: 'cart',
    lines: [{ merchandiseId: id, quantity: 1 }],
    promise: differe.promise,
  }));
  try {
    const r = await fetch(pnUrl(pnRoutes().cart_add_url || '/cart/add'), {
      method: 'POST', body: fd,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const rep = await r.json();
    if (rep.status) throw new Error(rep.message || rep.description || 'Ajout impossible');
    const panier = await fetch(pnUrl(pnRoutes().cart_url || '/cart'), { headers: { Accept: 'application/json' } }).then((x) => x.json());
    differe.resolve({
      cart: PnLignes.createCartFromAjaxResponse(panier),
      detail: { items: panier.items, source: 'pn-duo', sourceId: 'pn-duo', itemCount: 1, sections: rep.sections, didError: false },
    });
  } catch (err) {
    differe.reject(err);
    btn.disabled = false;
    btn.classList.remove('is-chargement');
    const aide = duo && duo.querySelector('[data-pn-aide]');
    if (aide) { aide.textContent = 'Ajout impossible pour le moment, réessayez.'; aide.hidden = false; }
  }
});

/* « En stock — reçu entre le … » : le morph du tiroir remet parfois le texte de repli du serveur dans un nœud déjà
   traité par snippets/lp-dates (dont l'observateur ne regarde que les éléments ajoutés). On le recalcule ici, avec la
   même fonction window.lpDates et le même format. */
const pnCourt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
const pnDates = () => {
  if (!window.lpDates) return;
  document.querySelectorAll('.pn-recu [data-lp-dates]').forEach((el) => {
    if (el.textContent.startsWith('entre')) return;
    const v = el.dataset.lpDates.split(',').map(Number); const d = window.lpDates(v[0], v[1]);
    el.textContent = `entre le ${pnCourt.format(d[0])} et le ${pnCourt.format(d[1])}`;
  });
};
new MutationObserver(() => requestAnimationFrame(pnDates)).observe(document.documentElement, { childList: true, subtree: true });
pnDates();

/* 02-11 (Bruno) : frise Commandé → Expédié → Livré dans le tiroir, sous la bande (snippets/cart-drawer).
   Le tiroir est re-rendu par morph à chaque changement : les dates repassent au texte de repli sans que l'observateur
   de lp-dates les revoie (il ne suit que les éléments ajoutés). On les remet ici, au format exact de lp-dates. */
const pnJm = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
const pnJ = new Intl.DateTimeFormat('fr-FR', { day: 'numeric' });
const pnFrise = () => {
  if (!window.lpDates) return;
  document.querySelectorAll('#cart-drawer .pn-frise [data-lp-date], #cart-drawer .pn-frise [data-lp-plage]').forEach((el) => {
    let t;
    if (el.dataset.lpDate) t = pnJm.format(el.dataset.lpDate === 'cmd' ? new Date() : window.lpDates(0, 0)[0]);
    else {
      const v = el.dataset.lpPlage.split(',').map(Number); const d = window.lpDates(v[0], v[1]);
      t = d[0].getMonth() === d[1].getMonth() ? `${pnJ.format(d[0])}–${pnJm.format(d[1])}` : `${pnJm.format(d[0])} – ${pnJm.format(d[1])}`;
    }
    if (el.textContent !== t) el.textContent = t;
  });
};
new MutationObserver(() => requestAnimationFrame(pnFrise)).observe(document.documentElement, { childList: true, subtree: true });
pnFrise();
